import fromAnyToLowerCase from 'utils/converters/any/fromAnyToLowerCase.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

export const isEqualByString = (a, b) => fromAnyToString(a) === fromAnyToString(b);
export const isEqualByCaseless = (a, b) => fromAnyToLowerCase(a) === fromAnyToLowerCase(b);
export const isEqualByTrimmed = (a, b) => fromAnyToTrimmed(a) === fromAnyToTrimmed(b);
